<template>
  <div class="ele-body">
    <el-card shadow="never" body-style="padding-bottom:0;">
      <el-row :gutter="15">
        <el-col :md="5" style="margin-bottom: 15px">
          <!-- 操作按钮 -->
          <div class="ele-table-tool ele-table-tool-default scope-tool">
            <el-button @click="showEditTarget = true" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">添加 </el-button>
            <el-button @click="editTarget" type="warning" icon="el-icon-edit" class="ele-btn-icon" :disabled="!currentTarget" size="small"
              >修改
            </el-button>
            <el-button @click="removeTarget" type="danger" icon="el-icon-delete" class="ele-btn-icon" :disabled="!currentTarget" size="small"
              >删除
            </el-button>
          </div>
          <!-- 数据表格 -->
          <ele-data-table
            ref="table"
            :config="targetTable"
            :data="targetData"
            :current.sync="currentTarget"
            highlight-current-row
            :height="tbHeight"
            class="dict-table"
            @row-click="clickTarget"
          >
            <el-table-column type="index" width="45" align="center" />
            <el-table-column prop="categoryName" label="指标大类" show-overflow-tooltip />
          </ele-data-table>
        </el-col>
        <el-col :md="19" style="margin-bottom: 15px">
          <div class="ele-table-tool ele-table-tool-default">
            <el-button @click="addTargetItem" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">添加</el-button>
          </div>
          <div class="resultGroup">
            <ele-data-table
              ref="categoryItemTable"
              :config="categoryItemTable"
              :data="categoryItemData"
              highlight-current-row
              class="dict-table"
              :initLoad="false"
            >
              <el-table-column type="index" width="45" align="center" />
              <el-table-column prop="itemName" label="指标名称" show-overflow-tooltip />
              <el-table-column prop="score" label="分值" show-overflow-tooltip />
              <el-table-column prop="createTime" label="创建时间" show-overflow-tooltip />
              <el-table-column label="操作" width="130px" align="center" :resizable="false">
                <template #default="{ row }">
                  <el-link @click="editCategoryItem(row)" icon="el-icon-edit" type="primary" :underline="false">修改</el-link>
                  <el-popconfirm title="确定要删除此指标吗？" @onConfirm="removeCategoryItem(row)" class="ele-action">
                    <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </ele-data-table>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <!-- 指标大类弹窗 -->
    <el-dialog
      :title="editTargetForm.id ? '修改宿舍量化考评指标大类' : '添加宿舍量化考评指标大类'"
      :visible.sync="showEditTarget"
      width="400px"
      @closed="editTargetForm = {}"
      :destroy-on-close="true"
      :lock-scroll="false"
    >
      <el-form :model="editTargetForm" ref="editTargetForm" :rules="editTargetRules" label-width="100px">
        <el-form-item label="指标大类:" prop="categoryName">
          <el-input v-model="editTargetForm.categoryName" placeholder="请输入指标大类名称" clearable />
        </el-form-item>
        <el-form-item label="序号:">
          <el-input-number
            v-model="editTargetForm.itemIndex"
            controls-position="right"
            :min="0"
            class="ele-fluid ele-text-left"
            placeholder="请输入序号"
            clearable
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showEditTarget = false">取消</el-button>
        <el-button type="primary" @click="saveTarget(editTargetForm.categoryId)">保存</el-button>
      </div>
    </el-dialog>
    <!--指标item弹窗-->
    <el-dialog
      :title="editCategoryItemForm.id ? '修改宿舍量化考评指标' : '添加宿舍量化考评指标'"
      :visible.sync="showEditCategoryItem"
      width="400px"
      @closed="editCategoryItemForm = {}"
      :destroy-on-close="true"
      :lock-scroll="false"
    >
      <el-form :model="editCategoryItemForm" ref="editCategoryItemForm" :rules="editCategoryItemRules" label-width="100px">
        <el-form-item label="指标名称:" prop="itemName">
          <el-input v-model="editCategoryItemForm.itemName" placeholder="请输入指标名称" clearable />
        </el-form-item>
        <el-form-item label="分值:" prop="score">
          <el-input-number
            v-model="editCategoryItemForm.score"
            controls-position="right"
            :precision="1"
            :step="0.1"
            class="ele-fluid ele-text-left"
            placeholder="请输入分值"
            clearable
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showEditCategoryItem = false">取消</el-button>
        <el-button type="primary" @click="saveCategoryItem(editCategoryItemForm.id)">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    addDormitoryAssessCategory,
    addDormitoryAssessItem,
    deleteDormitoryAssessCategory,
    deleteDormitoryAssessItem,
    getDormitoryAssessCategory,
    getDormitoryAssessItem,
    updateDormitoryAssessCategory,
    updateDormitoryAssessItem,
  } from '@/config/api';

  export default {
    name: 'Index',
    data() {
      return {
        targetData: [],
        targetTable: {
          page: false,
        },
        currentTarget: null, // 表格选中数据
        showEditTarget: false, // 是否显示表单弹窗
        editTargetForm: {}, // 表单数据
        editTargetRules: {
          // 表单验证规则
          categoryName: [{ required: true, message: '请输入指标大类名称', trigger: 'blur' }],
        },
        categoryId: null,
        categoryItemData: [],
        categoryItemTable: {
          page: false,
        },
        showEditCategoryItem: false,
        editCategoryItemForm: {},
        editCategoryItemRules: {
          itemName: [{ required: true, message: '请输入指标名称', trigger: 'blur' }],
          score: [{ required: true, message: '请输入分数', trigger: 'blur' }],
        },
      };
    },
    computed: {
      /* 表格固定高度 */
      tbHeight() {
        return this.$store.state.theme.screenWidth < 992 ? undefined : 'calc(100vh - 214px)';
      },
    },
    created() {
      this.queryTargetList();
    },
    methods: {
      // 查询指标大类列表
      queryTargetList() {
        getDormitoryAssessCategory().then((res) => {
          if (res.data.resCode == 200) {
            this.targetData = res.data.data;
          }
        });
      },
      // 保存指标大类
      saveTarget(id) {
        this.$refs['editTargetForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.editTargetForm) {
              if (this.editTargetForm[key] !== null && this.editTargetForm[key] !== undefined) {
                formData.append(key, this.editTargetForm[key]);
              }
            }
            if (id == undefined) {
              // 新增指标大类
              addDormitoryAssessCategory(formData).then((res) => {
                loading.close();
                if (res.data.resCode == 200) {
                  this.showEditTarget = false;
                  this.$message({ type: 'success', message: res.data.resMsg });
                  this.queryTargetList();
                } else {
                  this.$message.error(res.data.resMsg);
                }
              });
            } else {
              // 编辑指标大类
              updateDormitoryAssessCategory(formData).then((res) => {
                loading.close();
                if (res.data.resCode == 200) {
                  this.showEditTarget = false;
                  this.$message({ type: 'success', message: res.data.resMsg });
                  this.queryTargetList();
                } else {
                  this.$message.error(res.data.resMsg);
                }
              });
            }
          } else {
            return false;
          }
        });
      },
      // 点击指标大类获取指标item
      clickTarget(row) {
        this.currentTarget = row;
        this.categoryId = row.categoryId;
        this.queryCategoryItem(row.categoryId);
      },
      // 编辑指标大类
      editTarget() {
        this.editTargetForm = Object.assign({}, this.currentTarget, {});
        this.showEditTarget = true;
      },
      // 删除指标大类
      removeTarget() {
        this.$confirm('确定要删除选中的指标大类吗?', '提示', {
          type: 'warning',
        }).then(() => {
          const loading = this.$loading({ lock: true });
          let formData = new FormData();
          formData.append('categoryId', this.currentTarget.categoryId);
          deleteDormitoryAssessCategory(formData).then((res) => {
            loading.close();
            if (res.data.resCode == 200) {
              this.showEditTarget = false;
              this.$message({ type: 'success', message: res.data.resMsg });
              this.queryTargetList();
            } else {
              this.$message.error(res.data.resMsg);
            }
          });
        });
      },
      // 获取指标列表
      queryCategoryItem(categoryId) {
        getDormitoryAssessItem({ categoryId: categoryId }).then((res) => {
          if (res.data.resCode == 200) {
            this.categoryItemData = res.data.data;
          }
        });
      },
      // 添加指标
      addTargetItem() {
        this.editCategoryItemForm.categoryId = this.categoryId;
        this.showEditCategoryItem = true;
      },
      // 保存或编辑指标
      saveCategoryItem(id) {
        this.$refs['editCategoryItemForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.editCategoryItemForm) {
              if (this.editCategoryItemForm[key] !== null && this.editCategoryItemForm[key] !== undefined) {
                formData.append(key, this.editCategoryItemForm[key]);
              }
            }
            if (id == undefined) {
              // 添加指标
              addDormitoryAssessItem(formData).then((res) => {
                loading.close();
                if (res.data.resCode == 200) {
                  this.showEditCategoryItem = false;
                  this.$message({ type: 'success', message: res.data.resMsg });
                  this.queryCategoryItem(this.categoryId);
                } else {
                  this.$message.error(res.data.resMsg);
                }
              });
            } else {
              // 编辑指标
              updateDormitoryAssessItem(formData).then((res) => {
                loading.close();
                if (res.data.resCode == 200) {
                  this.showEditCategoryItem = false;
                  this.$message({ type: 'success', message: res.data.resMsg });
                  this.queryCategoryItem(this.categoryId);
                } else {
                  this.$message.error(res.data.resMsg);
                }
              });
            }
          } else {
            return false;
          }
        });
      },
      // 指标编辑弹窗 控制
      editCategoryItem(row) {
        this.editCategoryItemForm = Object.assign({}, row, {});
        this.showEditCategoryItem = true;
      },
      // 删除宿舍量化指标
      removeCategoryItem(row) {
        const loading = this.$loading({ lock: true });
        let formData = new FormData();
        formData.append('itemId', row.id);
        deleteDormitoryAssessItem(formData).then((res) => {
          loading.close();
          if (res.data.resCode == 200) {
            this.showEditCategoryItem = false;
            this.$message({ type: 'success', message: res.data.resMsg });
            this.queryCategoryItem(this.categoryId);
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
    },
  };
</script>

<style scoped>
  .scope-tool {
    justify-content: space-around;
  }
  .org-tree-group {
    border: 1px solid hsla(0, 0%, 60%, 0.15);
    height: calc(115vh - 275px);
    box-sizing: border-box;
    overflow-x: auto;
  }

  .org-tree-group >>> .el-tree-node__content {
    height: 40px;
  }

  .org-tree-group >>> .el-tree-node__content > .el-tree-node__expand-icon {
    margin-left: 10px;
  }
  .resultGroup {
    /*border: 1px solid hsla(0, 0%, 60%, 0.15);*/
    height: calc(100vh - 215px);
    box-sizing: border-box;
    overflow-x: auto;
  }
</style>
